import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { UseMutationOptions } from 'react-query/types/react/types';
import { CustomRolesApi } from '../../../api-client';
import { getApiConfiguration } from '../../../common';

type UseDeleteCustomRole = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>, ErrorResponse, string>, 'mutationFn'>,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, string>;

export const useDeleteCustomRole: UseDeleteCustomRole = (options) => {
  const customRolesApi = new CustomRolesApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation((id: string) => customRolesApi.deleteCustomRole(tenantId, id), options);
};
